import { render, staticRenderFns } from "./safe_zone_events.vue?vue&type=template&id=2a3eca8e"
import script from "./safe_zone_events.vue?vue&type=script&lang=js"
export * from "./safe_zone_events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports